import { render, staticRenderFns } from "./NoticeDropdown.vue?vue&type=template&id=0a80f072"
import script from "./NoticeDropdown.vue?vue&type=script&lang=js"
export * from "./NoticeDropdown.vue?vue&type=script&lang=js"
import style0 from "./NoticeDropdown.vue?vue&type=style&index=0&id=0a80f072&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports